import React, { useState, useEffect } from "react";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-tomorrow";

import { cleanHtmlString, formatHtml } from "./EmailHtmlHelper";

export default function EmailHtmlEditor({ initialHtml, handleOnChange }) {
  const [html, setHtml] = useState("");

  // Format only when initialHtml changes
  useEffect(() => {
    if (initialHtml) {
      const cleaned = cleanHtmlString(initialHtml);
      const formatted = formatHtml(cleaned);
      setHtml(formatted);
    }
  }, [initialHtml]);

  return (
    <div style={{ display: "flex", height: "90vh" }}>
      {/* Editor */}
      <div style={{ width: "50%" }}>
        <AceEditor
          mode="html"
          theme="tomorrow"
          value={html}
          onChange={(newvalue) => {
            handleOnChange(newvalue);
            setHtml(newvalue);
          }}
          name="email_editor"
          width="100%"
          height="calc(100% - 80px)"
          setOptions={{
            useWorker: false,
            tabSize: 2,
          }}
        />
      </div>

      {/* Live Preview */}
      <div style={{ width: "50%", borderLeft: "1px solid #ddd" }}>
        <iframe
          title="preview"
          srcDoc={html}
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>
    </div>
  );
}
